export default {
    apiKey: "AIzaSyDisWuJldAh43ZL3XrDVP3gVuJf2Tzu0Ig",
    authDomain: "persat-payments.firebaseapp.com",
    databaseURL: "https://persat-payments.firebaseio.com",
    projectId: "persat-payments",
    storageBucket: "persat-payments.appspot.com",
    messagingSenderId: "274451226147",
    appId: "1:274451226147:web:99da7711c0853a9d751b96"
};
